"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const isPlainObject_1 = __importDefault(require("lodash/isPlainObject"));
const getPrintableError = (validationErrors) => {
    const printableErrors = Object.keys(validationErrors)
        .map(key => {
        return `${key}: ${validationErrors[key]}`;
    })
        .join(', ');
    const message = `Validation Error: {${printableErrors}}`;
    return message;
};
class ValidationError extends Error {
    constructor(validationErrors) {
        super(getPrintableError(validationErrors));
        this.getInfo = () => {
            return {
                error: 'validationError',
                message: 'Validation Error',
                validationErrors: this.validationErrors
            };
        };
        this.prependKey = prepend => {
            const newErrors = {};
            const keys = Object.keys(this.validationErrors);
            for (const key of keys) {
                newErrors[`${prepend}.${key}`] = this.validationErrors[key];
            }
            return new ValidationError(newErrors);
        };
        if (!(0, isPlainObject_1.default)(validationErrors)) {
            throw new Error('ValidationError must be initialized with an errors object');
        }
        Error.captureStackTrace(this, this.constructor);
        this.code = 'validationError';
        this.isValidationError = true;
        this.isOrionError = true;
        this.validationErrors = validationErrors;
        this.getInfo;
    }
}
exports.default = ValidationError;
